import React from "react";
import styles from "./admin.module.scss";
import cx from "./cx";

interface CardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Shown to the right of the title. */
  actions?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  actions,
  className,
  style,
  children,
}) => (
  <section className={cx(styles.card, className)} style={style}>
    {(title || actions) && (
      <h2 className={styles.ct}>
        {title}
        {actions && <span className={styles.ctActions}>{actions}</span>}
      </h2>
    )}
    {subtitle && <div className={styles.cs}>{subtitle}</div>}
    {children}
  </section>
);

export default Card;
